import { Show } from "solid-js";
import { useAppState } from "@core/state/AppState";

export function ToastHost() {
  const appState = useAppState();
  const state = appState.snapshot();

  return (
    <div class="toast-host">
      <Show when={state.toast()}>
        {(toast) => (
          <div classList={{ toast: true, [`toast--${toast().type}`]: true }}>
            <span>{toast().message}</span>
            <button type="button" class="toast__close" onClick={() => appState.clearToast()}>
              ×
            </button>
          </div>
        )}
      </Show>
    </div>
  );
}
